module.exports = __webpack_public_path__ + "assets/img/familyCrest-ec8314dd.png";